import { Theme, styled } from '@material-ui/core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

type TrajectoryInfoLabelContext = 'draft' | 'notVisible' | 'frozen';

type Props = {
  inline?: boolean;
  context: TrajectoryInfoLabelContext;
};

const BoxWrapper = styled('span')<Theme>(({ theme }) => ({
  background: theme.palette.common.white,
  color: theme.palette.grey['700'],
  fontFamily: theme.config.secondaryFontFamily,
  display: 'flex',
  textTransform: 'uppercase',
  padding: theme.spacing(1),
  fontSize: theme.typography.h5.fontSize,
  alignItems: 'center',
  borderRadius: theme.config.defaultBorderRadius,
  border: `1px solid ${theme.config.appbarColors.borderColor}`,
  maxHeight: '2.6rem',
  '&.inline': {
    display: 'inline-flex',
  },
}));

export const TrajectoryInfoLabel: FC<Props> = ({ context, inline = false }) => {
  const { t } = useTranslation();

  return <BoxWrapper className={inline ? 'inline' : undefined}>{t(`${context}.label`)}</BoxWrapper>;
};
